import React, { useState } from 'react'
import { Language, t } from '../data/translations'
import ProtectorDefenseImg from '../assets/cards/classic/Protector_Defense.png'
import ProtectorAttackImg from '../assets/cards/classic/Protector_Attack.png'

interface ProtectorChoiceModalProps {
  onChoose: (mode: 'ATTACK' | 'DEFENSE') => void
  language: Language
}

const ProtectorChoiceModal: React.FC<ProtectorChoiceModalProps> = ({ onChoose, language }) => {
  const [hoveredOption, setHoveredOption] = useState<'ATTACK' | 'DEFENSE' | null>(null)

  return (
    <div className="absolute inset-0 bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center z-40">
      <h2 className="text-4xl font-bold mb-8 text-slate-300 text-shadow-lg">
        {t('card.protector.chooseMode', language)}
      </h2>
      <div className="flex gap-8">
        {/* Defense Option */}
        <div
          onClick={() => onChoose('DEFENSE')}
          onMouseEnter={() => setHoveredOption('DEFENSE')}
          onMouseLeave={() => setHoveredOption(null)}
          className="relative flex flex-col items-center justify-center gap-4 p-6 bg-slate-800/70 rounded-lg border-2 border-blue-600 cursor-pointer transform hover:scale-110 hover:border-blue-300 transition-all duration-300"
        >
          <div className="relative w-28 h-36 overflow-hidden rounded-lg">
            <img
              src={ProtectorDefenseImg}
              alt={t('card.protector.defenseLabel', language)}
              className="w-full h-full object-cover"
            />
            {/* Floating hover label */}
            <div
              className={`absolute inset-0 flex items-center justify-center bg-blue-600/80 transition-all duration-300 ${hoveredOption === 'DEFENSE' ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
                }`}
            >
              <span className="text-white font-bold text-lg text-center drop-shadow-lg px-2 animate-pulse">
                {t('card.protector.defenseEffect', language)}
              </span>
            </div>
          </div>
          <span className="font-bold text-xl text-blue-400">
            {t('card.protector.defenseLabel', language)}
          </span>
          <span className="text-sm text-slate-300">
            {t('card.protector.defenseEffect', language)}
          </span>
        </div>

        {/* Attack Option */}
        <div
          onClick={() => onChoose('ATTACK')}
          onMouseEnter={() => setHoveredOption('ATTACK')}
          onMouseLeave={() => setHoveredOption(null)}
          className="relative flex flex-col items-center justify-center gap-4 p-6 bg-slate-800/70 rounded-lg border-2 border-red-600 cursor-pointer transform hover:scale-110 hover:border-red-300 transition-all duration-300"
        >
          <div className="relative w-28 h-36 overflow-hidden rounded-lg">
            <img
              src={ProtectorAttackImg}
              alt={t('card.protector.attackLabel', language)}
              className="w-full h-full object-cover"
            />
            {/* Floating hover label */}
            <div
              className={`absolute inset-0 flex items-center justify-center bg-red-600/80 transition-all duration-300 ${hoveredOption === 'ATTACK' ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
                }`}
            >
              <span className="text-white font-bold text-lg text-center drop-shadow-lg px-2 animate-pulse">
                {t('card.protector.attackEffect', language)}
              </span>
            </div>
          </div>
          <span className="font-bold text-xl text-red-400">
            {t('card.protector.attackLabel', language)}
          </span>
          <span className="text-sm text-slate-300">
            {t('card.protector.attackEffect', language)}
          </span>
        </div>
      </div>
      <p className="text-cyan-400 mt-4 text-lg">
        {t('card.protector.passiveHeal', language)}
      </p>
    </div>
  )
}

export default ProtectorChoiceModal
